import { Component, input, output } from '@angular/core';

@Component({
  selector: 'ui-checkbox',
  standalone: true,
  template: `
    <div class="checkbox-square" [class.selected]="checked()" [class.disabled]="disabled()" (click)="toggle($event)">
      @if (checked()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="3.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          class="checkmark"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      }
    </div>
  `,
  styles: [
    `
      :host {
        display: inline-block;
        vertical-align: middle;
        user-select: none;
      }

      .checkbox-square {
        width: 16px;
        height: 16px;
        border: 2px solid #5f6368;
        border-radius: 4px;
        background: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: all 0.2s ease;
        cursor: pointer;
        box-sizing: border-box;

        &:hover:not(.disabled) {
          border-color: #5a73c5;
        }

        &.selected {
          background-color: #5a73c5;
          border-color: #5a73c5;

          .checkmark {
            color: white;
            display: block;
          }
        }

        &.disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    `,
  ],
})
export class CheckboxComponent {
  checked = input<boolean>(false);
  disabled = input<boolean>(false);
  checkedChange = output<boolean>();

  toggle(event: Event) {
    event.stopPropagation();
    if (this.disabled()) return;
    this.checkedChange.emit(!this.checked());
  }
}
